import { render, staticRenderFns } from "./referpatient.vue?vue&type=template&id=dbbcb7ec&"
import script from "./referpatient.vue?vue&type=script&lang=js&"
export * from "./referpatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports